const main = () => {
  let bc;
  if ('BroadcastChannel' in window) {
    bc = new BroadcastChannel('cn');
    bc.onmessage = ({ data }) => {
      if (data === 'reload') {
        setTimeout(() => {
          window.location.reload();
        });
      }
    };
  }
  return bc;
};

export default main();
